import React, { Component } from 'react';
import './DeliveryCountdown.scss';
import { formatDuration, intervalToDuration } from 'date-fns'

const ScentSelectorModal = (props) => {
  let duration = intervalToDuration({
    start: new Date(2022, 6, 2, 0, 0, 15), 
    end: new Date(),
})




  return (
      <div>ORDER WITHIN X HOURS & RECEIVE YOUR ORDER THURS 9TH


        {/* {formatDuration(duration, {
          format: 'hours',
          // delimiter: ', '
})} */}
      </div>
    )
  
  
}

export default ScentSelectorModal;
